import {CrudApiService} from "@/services/api/api.base.js";

export class UsersApiService extends CrudApiService {
  constructor(resource, notifier, callback) {
    super(resource, notifier, callback);
  }

  async addUser(params) {
    const data = await super.post("add", params);
    return data;
  }

  async updUsersList(params) {
    await super.post("list", params);
    return true;
  }

  async delUser(id) {
    const data = await super.delete(`${id}`);
    return data;
  }

  async getUsers() {
    const data = await super.get("list");
    return data;
  }
}